export const makeQueryParams = (paramsIn: any): URLSearchParams => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(paramsIn))
      if (value)
        if (Array.isArray(value) && value !== null) value.forEach((el) => params.append(key, el));
        else if (typeof value !== 'object') params.append(key, `${value}`);

    return params;
  };

// export const getFormattedLink = (link: string) => {
//   try {
//     return decodeURI(link);
//   } catch (error) {
//     console.error({ error });
//     return link;
//   }
// };
